// T4/100A01: Menú lateral en los submódulos (components/Body.js). Entra oculto
// (barra de iconos); se puede mostrar con el botón. Al elegir un departamento
// vuelve al inicio con esa pestaña, igual que el inicio guarda su pestaña en
// localStorage "HOME-TAB" (components/home/index.js:32-41).
// T4/100A02: sin useState. Antes: import React, { useState } from "react";
// T4/100A04: vuelve useState para el menú colapsable en celular.
import React, { useState } from "react";
import useIsMobile from "Hooks/useIsMobile";
import { useNavigate } from "react-router-dom";
import AppSidebar from "./AppSidebar";
import { useSidebarTabs } from "./useSidebarTabs";

const HOME_TAB = "HOME-TAB";

const readHomeTab = () => {
  try {
    return localStorage.getItem(HOME_TAB);
  } catch (error) {
    console.error("[Menú lateral] No se pudo leer la pestaña activa:", error);
    return null;
  }
};

const BodySidebar = () => {
  const tabs = useSidebarTabs();
  const navigate = useNavigate();
  // T4/100A02: sin estado oculto/visible. Antes: const [collapsed, setCollapsed] = useState(true);
  // T4/100A04: solo en celular: entra oculto y se abre con el botón.
  const isMobile = useIsMobile();
  const [collapsed, setCollapsed] = useState(true);

  const select = (key) => {
    try {
      localStorage.setItem(HOME_TAB, key);
    } catch (error) {
      console.error("[Menú lateral] No se pudo guardar la pestaña:", error);
    }
    navigate("/");
  };

  return (
    // T4/100A02: menú fijo y abierto también en los submódulos (sin ocultar). Antes:
    // <AppSidebar tabs={tabs} active={readHomeTab()} onSelect={select} collapsible
    //   collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} />
    // T4/100A04: antes <AppSidebar tabs={tabs} active={readHomeTab()} onSelect={select} />
    <AppSidebar
      tabs={tabs}
      active={readHomeTab()}
      onSelect={select}
      collapsible={isMobile}
      collapsed={collapsed}
      onToggle={() => setCollapsed((c) => !c)}
    />
  );
};

export default BodySidebar;
